<script setup lang="ts">
	import Socials from "~/components/Layout/Socials.vue";

	interface NavigationItem {
		label: string,
		name: string,
		slug?: string,
		title: string,
	}
	const $props = defineProps<{
		footerItems?: Array<NavigationItem[]>,
	}>()

	const { data: socials } = await useAsyncData(() => $fetch('/data/socials.json'))

	const cacheKey = 'profile'
	const profile = ref({})

	const cachedData = useNuxtData(cacheKey)
	if (cachedData.data.value && cachedData.data.value.info.count === 1) {
		profile.value = cachedData.data.value.items[0]
	}
</script>

<template>
	<nav v-if="profile?.navigation_links_display"  role="navigation">
		<ul class="divide-y divide-gray-200">
			<li v-for="(item,idx) in profile.navigation_links_display" class="relative py-2.5 lg:py-4">
				<NuxtLink v-if="item.url" :to="item.url" class="font-medium text-[22px] lg:text-[24px] whitespace-nowrap text-primary hover:!text-accent transition duration-300 ease-in-out" :title="item.title" no-prefetch>
					{{ item.title }}
				</NuxtLink>
			</li>
			<li v-for="(item,idx) in footerItems" class="relative py-2.5 lg:py-4">
				<NuxtLink v-if="item.name" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="font-medium text-[22px] lg:text-[24px] whitespace-nowrap text-primary hover:!text-accent transition duration-300 ease-in-out" :title="item.label" no-prefetch>
					{{ item.label }}
				</NuxtLink>
			</li>
		</ul>
	</nav>
	<hr class="my-4 border-silver-300/50" />
	<div class="flex flex-col justify-items-start mt-4">
		<div class="w-full flex flex-col justify-between gap-4 mb-12">
			<ProfileRegistrationBtn type="large"></ProfileRegistrationBtn>
			<ProfileResultBtn type="large"></ProfileResultBtn>
		</div>
		<LayoutSocials :items="socials"></LayoutSocials>
	</div>
</template>
